export default __webpack_public_path__ + "static/char-s-40-zh-Hans-ff363d6a49bdce3229749e357d570cbf.png";